import * as React from 'react';
import { Component } from '../../lib/component';
import { FormattedMessage } from 'react-intl';
import { Loading } from '../loading/loading';
import {important, px, rem} from 'csx';
import { classes, style } from 'typestyle';
import {betweenJustified, center, centerCenter, horizontal} from 'csstips';
import {RatecardGauge} from '../ratecard-gauge';
import {ButtonPill} from '../button-pill';
import {User} from '../../types/user';
import {ChannelSchema} from '../../types/schema';
import {formatCurrency} from '../../lib/currency';
import {colorSubtle} from '../../theme/color';

export interface AccountRateCardProps {
  className?: string;
  user: User;
  channel: ChannelSchema;
  loading: boolean;
}

export class AccountRateCard extends Component<AccountRateCardProps> {
  render() {
    const { user, channel, loading } = this.props;

    const className = classes(
      AccountRateCard.styles.container,
      (loading || !user || !channel || !channel.ratecard) && AccountRateCard.styles.containerEmpty,
      this.props.className
    );

    return (
      <div className={className}>
        {loading && (
          <div>
            <Loading />
          </div>
        )}
        {!loading && !user && (
          <div>
            <FormattedMessage id="account.rate_card.no_user" />
          </div>
        )}
        {!loading && user && (!channel || !channel.ratecard) && (
          <div>
            <FormattedMessage id="account.rate_card.no_channels" />
          </div>
        )}
        {user && channel && channel.ratecard && (
          <div key={channel.id}>
            <RatecardGauge
              ratecard={channel.ratecard}
              statistics={channel.ratecard_statistics}
            />
            <div className={AccountRateCard.styles.yourPrice}>
              <div className={AccountRateCard.styles.value}>
                <FormattedMessage id="account.rate_card.value" values={{ value: formatCurrency(channel.ratecard.value, channel.ratecard.currency) }} />
                <ButtonPill
                  muted={true}
                  className={AccountRateCard.styles.help}
                  href="/pricing"
                  children="?"
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  static styles = {
    container: style({
      padding: px(20),
      flexShrink: 0,
    }),
    containerEmpty: style({
      textAlign: 'center'
    }),
    split: style({
      ...horizontal,
      ...center,
      ...betweenJustified,
      margin: '0 0 20px 0',
      $nest: {
        '& > div': {
          flex: 1
        }
      }
    }),
    label: style({
      fontSize: rem(0.75),
      color: colorSubtle.toString(),
    }),
    channel: style({
      fontSize: rem(1.125),
      textOverflow: 'ellipsis',
      wordBreak: 'break-all',
      overflow: 'hidden',
    }),
    name: style({
      textAlign: 'right',
    }),
    value: style({
      fontSize: rem(1.125)
    }),
    help: style({
      width: important('14px'),
      height: important('14px'),
      fontSize: important('10px'),
      padding: important('0'),
    }),
    yourPrice: style({
      ...horizontal,
      ...centerCenter,
      $nest: {
        '&> div': {
          position: 'relative'
        }
      }
    })
  }
}